// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__xRTlO","head":"Products_head__T7DvF","title":"Products_title__ZwqKI","wrapper":"Products_wrapper__2SFur"};